import { Model } from "../models/model";
import { ViewColumn } from "./view-column";
import { IDataTableColumn } from "winfakt-vue-components";

export interface IResolvedSidebarField {
	label:string;
	html:string;
	text:string;
	right:boolean;
	center:boolean;
}

function htmlToText(html:string):string {
	let div = document.createElement("div");
	div.innerHTML = html;
	return (div.textContent || "").trim();
}

function resolveLabel(field:ViewColumn, model:Model):string {
	if (field.Name) return field.Name;
	let namedProp = model.getField(field.Property);
	return namedProp ? namedProp.getPropertyTranslation() : field.Property;
}

function resolveRawValue(column:IDataTableColumn, item:any):{value:any, lowestObj:any} {
	if (column.getValueFunc) {
		try {
			return {value: column.getValueFunc(item), lowestObj: item};
		} catch (err) {
			return {value: null, lowestObj: item};
		}
	}
	let lowestObj = item;
	let value:any = item;
	for (let part of column.property.split(".")) {
		if (value == null) {
			return {value: null, lowestObj};
		}
		lowestObj = value;
		value = value[part];
	}
	return {value, lowestObj};
}

function printValue(column:IDataTableColumn, value:any, item:any, lowestObj:any):string {
	if (column.print) {
		try {
			value = column.print(value, item, lowestObj);
		} catch (err) {
			value = "";
		}
	}
	if (value === undefined || value === null) return "";
	return `${value}`;
}

export function resolveSidebarFieldValue(field:ViewColumn, item:any, model:Model):IResolvedSidebarField {
	let column = field.getDataTableColumn(model);
	let raw = resolveRawValue(column, item);
	let html = printValue(column, raw.value, item, raw.lowestObj);
	return {
		label: resolveLabel(field, model),
		html,
		text: html.indexOf("<") == -1 ? html.trim() : htmlToText(html),
		right: !!column.right,
		center: !!column.center
	};
}
